var Mode = {
    "CURR-MODE" : 'release'
}
export default Mode


// WEBPACK FOOTER //
// ./src/config.js